export class StopPropagationBindingBehavior {
  bind(binding) {
    binding.standardCallSource = binding.callSource;
    binding.callSource = function (event) {
      this.standardCallSource(event);
      event.stopPropagation();
    };
  }

  unbind(binding) {
    binding.callSource = binding.standardCallSource;
    binding.standardCallSource = null;
  }
}
